import { render, staticRenderFns } from "./ai-builder.vue?vue&type=template&id=490d8b19&scoped=true"
import script from "./ai-builder.vue?vue&type=script&lang=ts"
export * from "./ai-builder.vue?vue&type=script&lang=ts"
import style0 from "./ai-builder.vue?vue&type=style&index=0&id=490d8b19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d8b19",
  null
  
)

export default component.exports